const ReviewOpenPrice = () => {
  return (
    <div className='flex flex-col'>
      <span>Valor aberto.</span>
      <span>Preço definido pelo cliente.</span>
    </div>
  );
};

export default ReviewOpenPrice;
